import blog1 from "../assets/images/repositories/blog_1.png";
import blog2 from "../assets/images/repositories/blog_2.png";
import blog3 from "../assets/images/repositories/blog_3.png";
import portfolio from "../assets/images/repositories/portfolio.png";
import portfoliov2 from "../assets/images/repositories/portfolio-v2.png";
import quickstart from "../assets/images/repositories/quickstart.jpeg";
import cardportfolio from "../assets/images/repositories/cardportfolio.jpeg";
import imgGallery from "../assets/images/repositories/image_gallery.png";
import notebook from "../assets/images/repositories/notebook_app.png";
import devto from "../assets/images/repositories/devto.png";
import url_shortner from "../assets/images/repositories/url_shortner.png";
import markopolo from "../assets/images/repositories/markopolo.png";
import muktopaath from "../assets/images/repositories/muktopaath.png";
import code_runner from "../assets/images/repositories/code_runner.png";
import rick_and_morty from "../assets/images/repositories/rick_and_morty.png";
import placeholder_image from "../assets/images/repositories/placeholder_image.png";

export const repositories = [
  {
    title: "Markopolo.ai",
    description: "A SAAS marteking tool",
    cover: markopolo,
    technologies: ["node","aws","next.js","gcp"],
    url: "https://markopolo.ai/",
    // live: "https://ma-ahmad.github.io/portfolio",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    // stars: "65",
    // fork: "12"
  },
  {
    title: "Muktopaath",
    description: "An E-learning platform",
    cover: muktopaath,
    technologies: ["node","php","nysql","vue.js"],
    url: "https://muktopaath.gov.bd/",
    // live: "https://ma-ahmad.github.io/portfolio",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    // stars: "65",
    // fork: "12"
  },
  {
    title: "Scaleable URL Shortner",
    description: "A Scaleable url shortnet with node",
    cover: url_shortner,
    technologies: ["node", "next","zookeeper","mongodb","typescript"],
    url: "https://github.com/aistiak/scaleable-url-shortner",
    // live: "https://ma-ahmad.github.io/portfolio",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    // stars: "65",
    // fork: "12"
  },
  {
    title: "Code Runner",
    description: "A Simple code runner ",
    cover: code_runner,
    technologies: ["node", "docker","react","typescript"],
    url: "https://github.com/aistiak/code-runner/",
    // live: "https://ma-ahmad.github.io/portfolio",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    // stars: "65",
    // fork: "12"
  },
  {
    title: "Rick and morty app",
    description: "Generates rick and morty character",
    cover: rick_and_morty,
    technologies: ["node", "next","graphql","docker"],
    url: "https://github.com/aistiak/who-are-you",
    // live: "https://ma-ahmad.github.io/portfolio",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    // stars: "65",
    // fork: "12"
  },
  {
    title: "Daily Learn",
    description: "Repository for learning SWE topics and tools",
    cover: placeholder_image,
    technologies: ["md"],
    url: "https://github.com/aistiak/master-react",
    // live: "https://ma-ahmad.github.io/portfolio",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    // stars: "65",
    // fork: "12"
  }
  // {
  //   title: "Video-to-text",
  //   description: "Convert a video to text using ruby.",
  //   cover: "",
  //   technologies: ["ruby"],
  //   url: "https://github.com/MA-Ahmad/Video-to-text",
  //   blurHash: "L4S~x5xb~q$*~WR6MykCx^Vt4TtP",
  //   stars: "3"
  // },
  // {
  //   title: "Authentication API",
  //   description:
  //     "Simple Authentication API that can be used with any front-end app like React, Vue, Angular app.",
  //   technologies: ["ruby", "rails"],
  //   url: "https://github.com/MA-Ahmad/rails-authentication-app",
  //   blurHash: "L4S~x5xb~q$*~WR6MykCx^Vt4TtP",
  //   stars: "2"
  // }
];
